import React from "react";

const Service = () => {
  return (
    <div className="card card-compact lg:w-96 bg-base-100 shadow-xl">
      <figure>{/* <img src={brand_img} alt="Shoes" /> */}</figure>
      <div className="card-body">
        <h2 className="card-title text-primary">Service Name</h2>
        <p>Details</p>
      </div>
    </div>
  );
};

export default Service;
